import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';
import { ensureDemoSeedVersion } from './lib/demoSeedVersion';

// Discard demo state left by an older build BEFORE React mounts. The demo stores read
// localStorage inside useState initialisers, which run during the first render — if this ran
// any later, a component would already have initialised from stale state and would never
// re-read it. Silent in production; no-op when the stamp is already current.
ensureDemoSeedVersion();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
